import React, { useState } from 'react';
import MarketingShell from '../../components/MarketingShell';

export default function ConsultationPage({ title, description }) {
  const [sent, setSent] = useState(false);

  const onSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const body = `Name: ${data.get('name')}\nEmail: ${data.get('email')}\nCompany: ${data.get('company')}\n\n${data.get('message')}`;
    window.location.href = `mailto:hello@getupgraded.ai?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(body)}`;
    setSent(true);
  };

  return (
    <MarketingShell title={title} description={description}>
      <form onSubmit={onSubmit} className="space-y-4 rounded-xl border border-gray-100 bg-white p-6">
        <label className="block text-xs font-medium text-gray-700">
          Name
          <input name="name" required className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-900 focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900" />
        </label>
        <label className="block text-xs font-medium text-gray-700">
          Work email
          <input name="email" type="email" required className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-900 focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900" />
        </label>
        <label className="block text-xs font-medium text-gray-700">
          Company
          <input name="company" className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-900 focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900" />
        </label>
        <label className="block text-xs font-medium text-gray-700">
          How can we help?
          <textarea name="message" rows={4} className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-900 focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900" />
        </label>
        <button type="submit" className="inline-flex items-center rounded-lg bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800 transition-colors">
          {sent ? 'Opening email' : 'Send'}
        </button>
      </form>
    </MarketingShell>
  );
}
